import React from 'react';

import { Spinner } from '$HVUI';

class Failure extends React.Component {
    state = { showLoading: true, timer: null };
    componentDidMount() {
        this._isMounted = true;
        const timer = setTimeout(() => {
            if (this._isMounted) {
                this.setState({ showLoading: false });
            }
        });
        this.setState({ timer });
    }
    componentWillUnmount() {
        this._isMounted = false;
        const { timer } = this.state;
        if (timer) clearTimeout(timer);
    }
    render() {
        const { header, message } = this.props;
        const { showLoading } = this.state;

        if (showLoading) {
            return (
                <div
                    className="error-spinner-container"
                    data-testid="error-spinner-container"
                >
                    <Spinner
                        id="error-spinner-loading"
                        style={{ width: '50px', margin: '3em' }}
                    />
                </div>
            );
        }
        return (
            <div className="error-container" data-testid="error-container">
                <h1 style={{ marginTop: '24px', marginBottom: '48px' }}>
                    {header || 'Sorry, an error occurred.'}
                </h1>
                <p
                    style={{
                        fontSize: '1.2em',
                        maxWidth: '60%',
                        margin: '0 auto'
                    }}
                >
                    {message || 'Please try again later.'}
                </p>
            </div>
        );
    }
}

export default Failure;
